export const OFFICE_IDS = {
  SOLEA_DEMO: '22a6abed-48c8-4308-b600-e87db6f46628',
  HORIZON: '4a489a9b-51e0-45f6-a85c-bc00a8d660db',
  GREENCORE: '0689d530-4113-4f8d-adc7-1b77abfbf7d9',
  APOLLOX: 'e7c21e46-b6f1-439f-8b98-65e32d4b4be5',
  ANTHEM: '42d76702-2d7e-474e-a664-0bf1ae7bc002',
  MEDECKE: '9f33596b-e5e1-41c7-98eb-373b3af30780',
};
